import { Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BarChart3, Library, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HelpButton } from "./HelpButton.tsx";
import { useHelp } from "@/lib/help.ts";
import { lazyNamed } from "@/lib/lazyLoad.ts";
import { ThemeToggle } from "./ThemeToggle.tsx";

export const PRODUCT_NAME = "Pass the Verse";

export const loadHelpDialog = () => import("./HelpDialog.tsx");
const HelpDialog = lazyNamed(loadHelpDialog, "HelpDialog");

/** The help overlay (with the whole changelog) is downloaded the first time it opens, then stays mounted. */
function HelpDialogWhenOpened() {
  const open = useHelp((s) => s.open);
  const [wanted, setWanted] = useState(open);
  useEffect(() => {
    if (open) setWanted(true);
  }, [open]);
  return wanted ? (
    <Suspense fallback={null}>
      <HelpDialog />
    </Suspense>
  ) : null;
}

export function Masthead() {
  return (
    <div className="mx-auto flex max-w-2xl items-center justify-between gap-2 px-4 py-3 sm:px-8 sm:py-4">
      <Link to="/" className="group flex shrink-0 items-baseline gap-[0.28em] whitespace-nowrap rounded-sm font-display text-[1.45rem] leading-none tracking-tight sm:text-[1.9rem]" aria-label={`${PRODUCT_NAME}, home`}>
        <span>Pass the</span>
        <span className="italic text-brand transition-transform group-hover:-translate-y-0.5">Verse</span>
      </Link>
      <nav aria-label="Site" className="-mr-1.5 flex items-center sm:mr-0 sm:gap-0.5">
        <Button variant="ghost" size="icon" asChild aria-label="Send a verse to someone" title="Send a verse" className="size-9">
          <Link to="/send">
            <Send className="size-[1.15rem]" aria-hidden />
          </Link>
        </Button>
        <Button variant="ghost" size="icon" asChild aria-label="Your progress" title="Your progress" className="size-9">
          <Link to="/progress">
            <BarChart3 className="size-[1.15rem]" aria-hidden />
          </Link>
        </Button>
        <Button variant="ghost" size="icon" asChild aria-label="All verses" title="All verses" className="size-9">
          <Link to="/challenges">
            <Library className="size-[1.15rem]" aria-hidden />
          </Link>
        </Button>
        <HelpButton />
        <ThemeToggle />
      </nav>
      <HelpDialogWhenOpened />
    </div>
  );
}
